/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function UserAdd({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#UserAdd_svg__a)"><path fillRule="evenodd" d="M6.25.9a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2m-2.4 3.6a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0M5.381 9.4c-1.967 0-3.692 1.307-4.28 3.21l-.128.41c-.312 1.008.415 2.08 1.5 2.08h7.554c1.085 0 1.812-1.072 1.5-2.08l-.127-.41C10.81 10.708 9.086 9.4 7.119 9.4zm-3.135 3.565c.44-1.418 1.713-2.365 3.135-2.365h1.738c1.422 0 2.696.947 3.135 2.365l.126.41c.087.28-.122.525-.353.525H2.473c-.231 0-.44-.245-.353-.526z" clipRule="evenodd" /><path d="M13 5.4a.6.6 0 0 1 .6.6v1.4H15a.6.6 0 1 1 0 1.2h-1.4V10a.6.6 0 1 1-1.2 0V8.6H11a.6.6 0 1 1 0-1.2h1.4V6a.6.6 0 0 1 .6-.6" /></g><defs><clipPath id="UserAdd_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;